import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-detail",
  "use": "vab-icon-detail-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-detail\">\n<path d=\"M15.25 8.25H16.75V14.25C16.75 15.075 16.075 15.75 15.25 15.75H4.75C3.925 15.75 3.25 15.075 3.25 14.25V6.75C3.25 5.925 3.925 5.25 4.75 5.25H13.75V6.75H4.75V14.25H15.25V8.25ZM13.75 8.25H6.25V9.75H13.75V8.25ZM12.25 11.25H6.25V12.75H12.25V11.25ZM15.25 6.75H16.75V5.25H15.25V6.75Z\" fill=\"#004C82\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol